import { connect } from 'react-redux';
import { searchLayoutByName, searchLocationAutocomplete } from 'redux/saga/entities/bound';
import { deepExtract } from 'helpers/deep';
import { decorateWith, withName } from 'helpers/decorator';
import { removeSearchboxHistoryItem, searchPanelItemSelected } from './SearchBox.saga';
import { HEADER_LAYOUT } from '../Search.constants';
import { PANEL_NAMES } from './SearchBox.constants';
import { LocationField } from './LocationField';
import {
  selectSearchBoxState,
  setOpenPanel,
  closeOpenPanel,
  clearLocationField,
  setLocationFieldValue,
} from './SearchBox.reducer';

const mapDispatchToProps = {
  onFieldFocus: setOpenPanel.bind(null, PANEL_NAMES.location),
  onSelect: searchPanelItemSelected.bind(null, PANEL_NAMES.location),
  onRemoveItem: removeSearchboxHistoryItem.bind(null, PANEL_NAMES.location),
  onClose: closeOpenPanel,
  onClear: clearLocationField,
  onValueChange: setLocationFieldValue,
};

export const mapStateToProps = state => {
  const searchBox = selectSearchBoxState(state);
  const { locationKey: lastKeyToHaveLoaded, locationFieldValue: inputValue } = searchBox;
  const { loading: headerDataLoading, data: headerData } = searchLayoutByName.select(state, HEADER_LAYOUT);
  const predictionData = searchLocationAutocomplete.data(state, searchBox.locationFieldValue);
  const isLoading = !!headerDataLoading || !!(inputValue && lastKeyToHaveLoaded !== inputValue);

  return {
    inputValue,
    blurredValue: deepExtract('locationName', searchBox.selectedLocation || searchBox.defaultLocation, ''),
    suggestions: (predictionData && predictionData.predictions) || [],
    history: deepExtract('location_history.data.location_history', headerData, []),
    isLoading,
  };
};

export const LocationFieldContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('LocationFieldContainer')
)(LocationField);
